import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme) => ({
  emptyContainer: {
    [theme.breakpoints.up('md')]: {
      margin: '100px 48px 0 !important',
      paddingBottom: '150px',
      height: 'calc(100% - 81px - 96px)',
    },
    [theme.breakpoints.down('md')]: {
      margin: '48px 24px 0 !important',
      paddingBottom: '48px !important',
    },
  },
  linkedListContainer: {
    borderTop: `1px solid ${colors.gray.l85}`,
    [theme.breakpoints.up('md')]: {
      padding: '96px 0',
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '24px',
      marginRight: '24px',
      padding: '24px 0',
    },
  },
  pageContainer: {
    backgroundColor: colors.white,
  },
}));
